<template>
  <section>
    <div v-if="!loading">
      <div v-if="information.message">
        
        <h1 class="m-0 p-0 mt-2 mb-3  link-header">
          <span v-html="information.message.subject"></span>
        </h1>

        <h2 class="m-0 p-0 mt-2 mb-1  link-header">
          {{ $t("ORGANISER") }}
        </h2>
        
        <UserInfo
          image="/img/default-avatar.png"
          :primary="createdName"
          :secondary="information.message.creator.email"
          :optional="createdTime"
        ></UserInfo>        
        
        <hr class="pb-0 mb-0 mt-2" />

        <div class="d-flex">
          <div style="width: 12rem;" class="ml-0 pl-0">
            <h2 class="m-0 p-0 mt-2 mb-1  link-header">{{ $t("FROM") }}</h2>
            {{
              FormatDateTime(information.message.settings.meeting_start_date)
            }}
          </div>
          <div style="width: 12rem;" class="ml-0 pl-0">
            <h2 class="m-0 p-0 mt-2 mb-1  link-header">{{ $t("TO") }}</h2>
            {{
              FormatDateTime(information.message.settings.meeting_end_date)
            }}
          </div>
        </div>

        <AcceptMeeting
          :link_uuid="link_uuid"
          :authenticated="authenticated"
          @DecidedMeeting="DecidedMeeting"
          :information="information"
        ></AcceptMeeting>
        
        <hr class="pb-0 mb-0 mt-2" v-if="information.recurrence" />

        <PickRecurrence
          class="mt-2"
          v-if="information.recurrence"
          :recurrence="information.recurrence"
          :startDate="information.message.settings.meeting_start_date"
          :endDate="information.message.settings.meeting_end_date"
          text-only
        ></PickRecurrence>

        <hr class="pb-0 mb-0 mt-2" />

        <div class="mt-2" v-if="attachments.length != 0">
          <span
            v-for="(item, index) in attachments"
            :key="index"
            class="ms-fontSize-12"
          >
            <Attachment
            :message_uuid="information.message.message_uuid"
            :link_uuid="link_uuid"
            :item="item"
            :index="index"></Attachment>
          </span>
        </div>
        
        <div
          v-if="
            information.auth_message != 'open_to_date' &&
              information.auth_message != 'open_from_date'
          "
        >
          <h2 class="m-0 p-0 mt-2 mb-1  link-header">
            {{ $t("DESCRIPTION") }}
          </h2>

          <BodyText :body="information.message.body"></BodyText>

          <hr class="pb-0 mb-2 mt-2" />


          <b-row>
            <b-col col lg="2">
              <b-button variant="dark" @click="JoinMeeting(true)">
                {{ $t("SECURELINK.JITSI.JOIN_MEETING_ANONYMOUS") }}
              </b-button>
            </b-col>
            <b-col col lg="2">
              <b-button variant="dark" @click="JoinMeeting(false)">
                {{ $t("SECURELINK.JITSI.JOIN_MEETING") }}
              </b-button>
            </b-col>
          </b-row>      

          <b-modal 
            id="joinMeetingModal"
            :dialog-class="teams.theme"
              no-header
              centered
              @ok="Connect"      
            v-model="showModal"            
            :cancel-title="$t('CANCEL')"
            :ok-title="$t('JOIN')"
            >
            <center>
            <div v-if="joinAnonymously">{{ $t('SECURELINK.JITSI.YOU_WILL_JOIN_AS_ANONYMOUSLY') }}</div>
            <div v-if="!joinAnonymously">{{ $t('SECURELINK.JITSI.YOU_WILL_JOIN_AS') }} {{ information.email }}</div>
              </center>
          </b-modal>



        </div>
      </div>
    </div>
  </section>
</template>
<script>
import AcceptMeeting from "../AcceptMeeting";
import PickRecurrence from "../../Input/PickRecurrence";
import UserInfo from "@/components/Layout/UserInfo";
import Attachment from "@/components/View/Attachment";
import BodyText from "@/components/View/BodyText";
export default {
  components: {
    UserInfo,
    Attachment,
    BodyText,
    PickRecurrence,
    AcceptMeeting
  },
  props: [
    "link_token",
    "link_uuid",
    "open_time",
    "loading",
    "information",
    "authenticated",
    "recurrence"
  ],
  data() {
    return {
      showModal: false,
      joinAnonymously: false,
      api: null,
      opened: false,
    };
  },
  methods: {
    async DecidedMeeting(){
      this.$emit('DecidedMeeting');
    },
    async JoinMeeting(anonymous) {
      this.joinAnonymously = anonymous;
      this.showModal = true;
    },
    parseJitsiUrlToMeetingData(jitsiUrl) {
      const url = new URL(jitsiUrl);

      const server = url.hostname;
      const room = url.pathname.replace("/", "");
      const token = url.searchParams.get("jwt");

      return {
        server,
        room,
        token,
        subject: ""
      };
    },
    async Connect() {
      try {
        let result = await this.$http.get(this.user.hostname + "/message/link/join/" + this.link_uuid + "?isAnomymous=" + this.joinAnonymously);        
        this.$emit('RefreshToken');        
        let meetingData = this.parseJitsiUrlToMeetingData(result.data);
        this.$store.dispatch("jitsi/openMeeting", {
          server: meetingData.server,
          room: meetingData.room,
          token: meetingData.token,
          subject: this.information.message.subject
        });
      } catch {
        console.log("Could not openMeeting");
      }
    },
    closeBtn() {
      this.$emit("closeBtn");
    },
  },
  computed: {
    isFinished() {
      return this.current > this.expire;
    },
    expire() {
      let date = new Date(this.information.message.settings.open_to_date);
      return date;
    },
    current() {
      let date = new Date();
      return date;
    },
    attachments() {
      return this.information.message.attachments.filter((attachment) => {
        return attachment.name != "join_url.txt";
      });
    },
    createdTime() {
      return this.FormatDateTime(this.information.message.created_date);
    },
    createdName() {
      return (
        this.information.message.creator.name +
        ", " +
        this.information.message.creator.organisation_name
      );
    },
  },
  mounted: function() {},
};
</script>
<style></style>
